import React from 'react'
import { Container, Alert } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import 'react-toggle/style.css'
import Header from '../header'
import Footer from '../footer'
import Providers from './providers'
import SecuredRoutes from './secured-routes'
import useConfig from '../../hooks/use-config'
import useClientLocation from '../../hooks/use-client-location'
import AuthorizedUser from './authorized-user'
import useApi from '../../hooks/use-api'
import Spinner from '../common/spinner-container'
import 'react-bootstrap-typeahead/css/Typeahead.css'

const App = () => {
    const { name, env, version } = useConfig()
    const { location } = useClientLocation()
    const { isLoading, isAvailable } = useApi()

    if (isLoading) {
        return (<Spinner/>)
    }

    if (!isAvailable) {
        return (<Alert className='text-center' variant='danger'>The server is unavailable. Please check back later.</Alert>)
    }

    console.log('Client Location:', location.pathname)
    console.log(`${name} (${env}): v${version}`)

    return (
        <Providers>
            <Header />
            <Container fluid>
                <AuthorizedUser component={SecuredRoutes} />
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable={false}
                    pauseOnHover
                />
            </Container>
            <Footer />
        </Providers>
    )
}

export default App
